import { useTranslation } from "react-i18next";
import TermsOfServiceEs from "../components/TermsOfService/TermsOfServiceEs";
import TermsOfServiceEn from "../components/TermsOfService/TermsOfServiceEn";

export default function TermsOfService() {
  const { i18n } = useTranslation();

  return (
    <div className="terms-policy">
      {i18n.language === "es" ? <TermsOfServiceEs /> : <TermsOfServiceEn />}
    </div>
  );
}
